import { client } from "../sanity/client";


export const getProducts = async () => {

    const query = `
    *[_type == "product"] | order(_createdAt desc){
    _id,
    _createdAt,
    name,
    slug,
    price,
    shortDescription,
    description,
    image{
        asset->{
            url
        }
    },
    category->{
        _id,
        title,
        slug
    },
    specifications,
    stock
}
    `;


    return await client.fetch(query);

};